import React, { useState } from "react";
import { Card, CardHeader, Divider, CardContent, makeStyles, CircularProgress, Grid, List, ListItem, ListItemText, Typography } from "@material-ui/core";
import clsx from 'clsx';
import moment from "moment";
import ReactTooltip from 'react-tooltip';
import {formatQty, formatNumber, colorGenerator, format, HtmlTooltip} from '../Utils';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import INDIA_TOPO_JSON from './india.topo.json';
import { ReportService } from "../Services/ReportService";
import { STATES } from "../Constants";
import { useHistory } from "react-router-dom";

const PROJECTION_CONFIG = {
    scale: 1000,
    center: [78.9629, 22.5937]
};

const useStyles = makeStyles(theme => ({
    root: { 
        minHeight: 190,
    },
    icon: {
        padding: 2
    },
    content: {
        paddingTop: 0,
        paddingBottom: 0,
        minHeight: 200,
        marginTop: 10
    },
    actions: {
        paddingTop: 0,
        justifyContent: 'flex-end'
    },
    arrowForwardIcon: {
        marginLeft: theme.spacing(1)
    },
    select: {
        marginTop: 8,
        marginLeft: 8
    },
    griditem: {
        // cursor: 'move'
    },
    loader: {
        marginTop: 40
    },
    geographyStyle: {
        default: {
          outline: 'none'
        },
        hover: {
          fill: '#ccc',
          transition: 'all 250ms',
          outline: 'none'
        },
        pressed: {
          outline: 'none'
        }
    },
    itemDivider: {
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
}));

const TopRankingStates = (props) => {
    const classes = useStyles();
    const count = 5;
    const history = useHistory();
    const {className, refresh, onRefreshFinish} = props;
    // const [isShown, setIsShown] = useState(false);
    const [data, setData] = useState([]);
    // const [type, setType] = React.useState('amount');
    const type = React.useState('amount');
    const [loading, setLoading] = useState(false);
    const [tooltipContent, setTooltipContent] = useState('');
    const colors = colorGenerator(count);
    const DEFAULT_COLOR = '#008000';
    const startdate = moment().startOf('isoWeek');
    const enddate = moment().endOf('isoWeek');

    React.useEffect(() => {
        if(refresh){
            console.log("Initializing Map");
            setLoading(true);
            ReportService.turnoverSummaryStateWise(moment().diff(startdate, 'days') - 1, startdate, enddate)
            .then(data => {
                console.log(data);
                data.summary.forEach((d, i) => {
                    d.color = colors[i];
                })
                setData(data.summary);
                setLoading(false);
                if(null != onRefreshFinish){
                    onRefreshFinish();
                }
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
                if(null != onRefreshFinish){
                    onRefreshFinish();
                }
            })
        }
    }, [refresh]);

    const onMouseEnter = (geo, current = { total_amount: 0 }) => {
        return () => {
            console.log(type);
            if(current.state === undefined){
                setTooltipContent(`${geo.properties.name}: ${current.total_amount}`);
            } else {
                setTooltipContent(`${geo.properties.name}: ${type === 'units' ? `${formatQty(current.total)} Units` : formatNumber(current.total_amount)}`);
            }
        };
    };
    
    const onMouseLeave = () => {
        setTooltipContent('');
    };

    const onClick = (data) => {
        history.push(`/report/delivery/statewise?state=${data.state}&startdate=${moment(startdate).format(format)}&enddate=${moment(enddate).format(format)}`);
    }

    return (
        <Grid item xl={12} lg={12} xs={12}>
            <Card 
                className={clsx(classes.root, className)}
                //onMouseEnter={() => setIsShown(true)}
                //onMouseLeave={() => setIsShown(false)}
                >
                <CardHeader 
                    title={'States wise Sales'}
                    className={classes.griditem}
                    titleTypographyProps={{align: 'left', variant: 'h6'}}/>
                <Divider />
                <CardContent className={classes.content}>
                    {
                        loading ?
                            <div className={classes.loader}>
                                <CircularProgress />
                            </div>
                        :
                        <div>
                            <Grid container>
                                <Grid item xs={12} lg={7}> 
                                    <ReactTooltip>{tooltipContent}</ReactTooltip>
                                    <ComposableMap
                                        projectionConfig={PROJECTION_CONFIG}
                                        projection="geoMercator"
                                        width={1000}
                                        height={585}
                                        data-tip=""
                                    >
                                        <Geographies geography={INDIA_TOPO_JSON}>
                                        {({ geographies }) =>
                                            geographies.map(geo => {
                                            const current = data.find(s => s.state === geo.id);
                                            return (
                                                <Geography
                                                    key={geo.rsmKey}
                                                    geography={geo}
                                                    fill={current ? current.color : DEFAULT_COLOR}
                                                    className={classes.geographyStyle}
                                                    onMouseEnter={onMouseEnter(geo, current)}
                                                    onMouseLeave={onMouseLeave}
                                                    onClick={(e) => {
                                                        current && onClick(current)
                                                    }}
                                                />
                                            );
                                            })
                                        }
                                        </Geographies>
                                    </ComposableMap>
                                </Grid>
                                <Grid item xs={12} lg={5}> 
                                    <List>
                                        {data.map((data, i) => (
                                            <HtmlTooltip key={i} arrow title="Click to view details">
                                                <ListItem
                                                    classes={{ divider: classes.itemDivider }}
                                                    divider
                                                    dense
                                                    style={{cursor: 'pointer'}}
                                                    onClick={() => onClick(data)}
                                                    key={data.state}
                                                >
                                                    <ListItemText
                                                        primary={STATES.find(s => s.code === data.state).name }
                                                        primaryTypographyProps={{ variant: 'subtitle2' , style: { fontSize: 14}}}
                                                    />
                                                    <Typography style={{fontSize: 14}} color="inherit">{formatNumber(data.total_amount)}</Typography>
                                                </ListItem>
                                            </HtmlTooltip>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </div>
                    }
                </CardContent>
            </Card>
        </Grid>
    );
};

export default TopRankingStates;